import axios from "axios"
export function getUserDashboardData(token, userId) {
    return axios.get(process.env.REACT_APP_API_URL + `/getUserDashboardData?userId=${userId}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}